import React from 'react';
import { connect } from 'react-redux';
import { studentGrade } from '../../utils/const';
import {
	updateGrade,
	handleInputChange,
	setShowGrade,
} from '../../redux/myCourse/myCourse.actions';
import Modal from 'react-bootstrap/Modal';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
import Button from 'react-bootstrap/Button';
const mapStateToProps = (state) => {
	const { profileDetails, utils, myCourse } = state.rootReducer;
	return {
		error: utils.errorPanel,
		success: profileDetails.success,
		showGrade: myCourse.showGrade,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setShowGrade: (val) => dispatch(setShowGrade(val)),
		updateGrade: () => dispatch(updateGrade()),
		handleInputChange: (event) => dispatch(handleInputChange(event)),
		setErrorMsg: (obj) => dispatch(setErrorPanel(obj)),
	};
};

const GetGrade = React.memo(function GetGrade({
	setShowGrade,
	showGrade,
	updateGrade,
	handleInputChange,
	error: { panelClass, panelMsg },
	success,
}) {
	return (
		<Modal
			show={showGrade}
			dialogClassName="modal-90w"
			onHide={() => setShowGrade(false)}
			backdrop={true}
			keyboard={false}
		>
			<Modal.Header closeButton>
				<h4 className="modal-title">Please select your class:</h4>
			</Modal.Header>
			<Modal.Body size="lg">
				<div className={panelClass}>{panelMsg}</div>
				<select
					id="studentGrade"
					name="studentGrade"
					className="form-control"
					required
					onChange={handleInputChange}
				>
					<option value="">Select Class:</option>
					{!!studentGrade &&
						studentGrade.map((val, index) => (
							<option value={index + 3} key={index}>
								{val}
							</option>
						))}
				</select>
				<div className="form-group text-right" style={{ paddingTop: '20px' }}>
					<Button
						aria-label="submit"
						className="btn btn-info go-next"
						onClick={updateGrade}
					>
						Submit
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
})

export default connect(mapStateToProps, mapDispatchToProps)(GetGrade);
